import { Component, OnInit, ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { CadastroUsuarioLote } from '../../shared/model/cadastro-usuario-lote';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';
import { CadastroUsuarioLoteReturn } from '../../shared/model/cadastro-usuario-lote-return';
import { Location } from '@angular/common';
import { saveAs } from 'file-saver';
import { UtilService } from '../../shared/service/util/util.service';

@Component({
  selector: 'app-cadastro-usuarios-lote',
  templateUrl: './cadastro-usuarios-lote.component.html',
  styleUrls: ['./cadastro-usuarios-lote.component.css']
})

export class CadastroUsuariosLoteComponent implements OnInit {
  showSpinner: boolean = false;
  fileToUpload: File = null;
  @ViewChild('inputFile', { static: true })
  inputFile: ElementRef;
  cadastro: CadastroUsuarioLote = new CadastroUsuarioLote();
  maxUsuarios = 0;

  constructor(
    private usuarioService: UsuarioService,
    private location: Location,
    private utilService: UtilService) {

  }

  ngOnInit() {
    this.usuarioService.maxUsuariosLote().subscribe(
      res => {
        this.maxUsuarios = res;
      }
    );
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    
    let reader = new FileReader();
    reader.readAsDataURL(this.fileToUpload);
    reader.onload = this.handleFile.bind(this);

    const name = this.fileToUpload.name;
    const type = name.substring(name.lastIndexOf(".") + 1);

    this.cadastro.fileName = name;

    if (type != "csv") {
      this.utilService.showError('Formato inválido. Selecione um arquivo no formato CSV.');
      this.fileToUpload = null;
      this.inputFile.nativeElement.value = "";
    }
  }

  handleFile(event) {
    var binaryString = event.target.result;
    this.cadastro.arqBase64 = btoa(binaryString);
  }

  enviar() {
    if (this.fileToUpload == null) {
      this.utilService.showError('Selecione um arquivo no formato CSV.');
    } else {
      this.showSpinner = true;
      this.cadastro.emailAdm = JSON.parse(localStorage.getItem("currentUser")).email
      this.cadastro.idOrganizacao = JSON.parse(localStorage.getItem("currentUser")).organizacaoId

      this.usuarioService.cadastrarLote(this.cadastro).subscribe(
        res => {
          var result: CadastroUsuarioLoteReturn = res;

          if (result.success) {
            this.utilService.showSuccess(result.message);
          } else {
            this.utilService.showError(result.message);
          }

          this.fileToUpload = null;
          this.inputFile.nativeElement.value = "";
          this.showSpinner = false;
        }
      );
    }
  }

  downloadModeloArquivo() {
    let res = "nome(obrigatorio)|email(obrigatorio)|CPF(opcional)";
    const filename = "ModeloPlanilha.csv";
    const blob = new Blob([res], { type: "text/csv;charset=utf-8" });
    saveAs(blob, filename);
  }

  cancel() {
    this.location.back();
  }
}
